module.exports = __webpack_public_path__ + "static/media/3560.454d01c2.jpg";